import React, { createContext, useRef } from "react";
import NotificationAlert from "react-notification-alert";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const notificationRef = useRef(null);
  // const [notificationOpen, setNotificationOpen] = useState(false);
  const notificationTimeout = useRef(null);

  const notify = (type, message) => {
    // if (notificationOpen) return;      // this line was preventing new notifications from being displayed at the same time

    // setNotificationOpen(true);

    if (notificationTimeout.current) {
      clearTimeout(notificationTimeout.current);    //If a previous notification's timer is still running, cancel that timer.
    }

    notificationRef.current.notificationAlert({
      place: "tc",
      icon: "ni ni-bell-55",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {message}
          </span>
        </div>
      ),
      type,
      autoDismiss: 5,
    });

    // setTimeout(() => setNotificationOpen(false), 5000);
    notificationTimeout.current = setTimeout(() => {
      notificationTimeout.current = null;   // Store the timer reference so it can be cleared when a new notification arrives before the previous 5-second timeout finishes.
    }, 5000);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationRef} />
      </div>
      {children}
    </NotificationContext.Provider>
  );
};
